/*
 * @Description: 
 * @Autor: yd
 * @Date: 2020-09-12 11:42:33
 * @LastEditors: yd
 * @LastEditTime: 2020-09-12 11:47:54
 */
// 代码逻辑配置
import http from '../httpConfig'

const table = "mrbase_sys_org_levels_change_process"


// 列表
export const getCodeLogicList = (params = {}) => {
  params['~table~'] = table
  return new Promise((resolve, reject) => {
    http.post('/api/codelogic/list-codelogic/v1', params)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}

// 新增
export const addCodeLogic = (params = {}) => {
  params['~table~'] = table
  return new Promise((resolve, reject) => {
    http.post('/api/codelogic/add-codelogic/v1', params)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}

// 详情
export const detailCodeLogic = (params = {}) => {
  params['~table~'] = table
  return new Promise((resolve, reject) => {
    http.post('/api/codelogic/find-codelogic/v1', params)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}

// 详情
export const updateCodeLogic = (params = {}) => {
  params['~table~'] = table
  return new Promise((resolve, reject) => {
    http.post('/api/codelogic/update-codelogic/v1', params)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}

// 删除
export const deleteCodeLogic = (params = {}) => {
  params['~table~'] = table
  return new Promise((resolve, reject) => {
    http.post('/api/codelogic/delete-codelogic/v1', params)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}
